import { Chip } from '@mui/material';

interface AddRemoteTargetsValueProps {
  id: number;
  name: string;
  onRemove: () => void;
}

export const AddRemoteTargetsValue = ({ id, name, onRemove }: AddRemoteTargetsValueProps) => {
  return (
    <Chip
      key={id}
      label={name}
      onDelete={onRemove}
      sx={{ justifyContent: 'space-between', px: 1, py: 1.75 }}
    />
  );
};
